import React from 'react'
import { DefaultSubheader } from './DefaultSubheader'
import { ThreeCSubheader } from './ThreeCSubheader'

export interface ISubheaderProps {
  pageKey: string
  title: string
  whyThisMattersSlug?: string
  isStartingExercise?: boolean
  gotoWhyThisMatters: (slug: string) => void
}

const Subheader = ({ pageKey, title, whyThisMattersSlug, isStartingExercise, gotoWhyThisMatters }: ISubheaderProps) => {
  const threeCCategories : string[] = ['cognitiveExercises', 'cardioExercises', 'centeredBreathing']

  if (title === '') { return null }

  const isSticky = pageKey === 'whyThisMatters'

  if (threeCCategories.indexOf(pageKey) >= 0) {
    return (
      <ThreeCSubheader pageKey={pageKey}  />
    )
  }

  const defaultSubheaderProps = {
    title,
    isSticky,
    whyThisMattersSlug,
    isStartingExercise,
    gotoWhyThisMatters,
  }

  return (
    <DefaultSubheader { ...defaultSubheaderProps } />      
  )
}


export { Subheader }